import React from "react";
import "../../styles/desktop/AlarmeModal.css";

import CaixaDaAguaPainel from "./CaixaDaAgua/CaixaDaAguaPainel";
import Bombas            from "./Bombas/Bombas";
import Monitoramento     from "./Monitoramento/monitoramento"

export default function AlarmeModal({ page, caixas = [], bombas = [], status, monitoramentoUtils }) {
  console.log("pagina do alarme: " + page)
  const renderContent = () => {
    switch (page) {
      case "CaixaDAgua":
        return (
          <>
            <h1 className="tituloCampo4">Alarmes Caixa D'água</h1>
            <div className="campoLegendaCaixadagua">
              {status === "loading" && <p className="loadingServidor">Aguardando resposta do servidor…</p>}
              {status === "error" && <p className="erroServidor">Sem resposta do servidor — tentando novamente…</p>}
              {status === "ok" && <CaixaDaAguaPainel caixas={caixas} />}
            </div>
          </>
        );

      case "Bombas":
        return (
          <>
            <h1 className="tituloCampo4">Alarmes Bombas</h1>
            <div className="campoAlarmes">
              <Bombas bombas={bombas} />
            </div>
          </>
        );

      case "CentralAlarmeIncendio":
        return (
          <>
            <h1 className="tituloCampo4">Central de Alarme de Incêndio</h1>
            <div>
              <Monitoramento monitoramentoUtils={monitoramentoUtils} />
            </div>
          </>
        );

      default:
        return null;
    }
  };

  return <div className="CampoAlarme tamanhoTotal\">{renderContent()}</div>;
}
